import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { openSpiritualServices } from './eventBridge';

const INCENSE_POINTS = [
  { ath: 0.233, atv: -4.669 },
  { ath: -1.525, atv: -2.746 },
  { ath: 1.478, atv: -4.61 },
  { ath: 2.615, atv: -2.486 },
  { ath: 11.742, atv: 14.22 },
  { ath: -1.803, atv: 18.775 },
  { ath: -9.677, atv: 16.664 },
];

const Layer = styled.svg`
  position: absolute;
  inset: 0;
  z-index: 15;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
`;

const Hit = styled.polygon`
  fill: rgba(0, 0, 0, 0.01);
  stroke: none;
  cursor: pointer;
  pointer-events: fill;
`;

type KrpanoSphere = {
  spheretoscreen?: (ath: number, atv: number) => { x?: number; y?: number };
};

const IncenseHitOverlay = () => {
  const [points, setPoints] = useState('');

  useEffect(() => {
    let alive = true;
    const draw = () => {
      if (!alive) return;
      const krpano = (window as unknown as { krpanoViewSnapshot?: KrpanoSphere })
        .krpanoViewSnapshot;
      if (typeof krpano?.spheretoscreen === 'function') {
        const mapped = INCENSE_POINTS.map(point => {
          const screen = krpano.spheretoscreen?.(point.ath, point.atv);
          const x = Number(screen?.x);
          const y = Number(screen?.y);
          if (!Number.isFinite(x) || !Number.isFinite(y)) return '';
          return `${x},${y}`;
        }).filter(Boolean);
        const next = mapped.length > 2 ? mapped.join(' ') : '';
        setPoints(current => (current === next ? current : next));
      }
      window.requestAnimationFrame(draw);
    };
    const frame = window.requestAnimationFrame(draw);
    return () => {
      alive = false;
      window.cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <Layer data-hit="incense" aria-hidden="true">
      {points ? (
        <Hit
          points={points}
          onClick={event => {
            event.stopPropagation();
            openSpiritualServices({ flow: 'incense' });
          }}
        />
      ) : null}
    </Layer>
  );
};

export default IncenseHitOverlay;
